import React from "react";
import Container from "../Container";
export default function Navbar() {
  return (
    <Container>
      <div className="flex flex-row justify-between mt-10 h-full ">
        <div className="flex flex-row md:gap-3 md:basis-6/12 w-full">
          <div className="flex flex-col">
            <p className="text-white body md:text-xl text-[10px] ">
              SHRAVARI PATIL
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
}
